import React from "react";
import styles from "./index.module.css";

const Tabs = ({ data }) => {
    return (
        <div className={styles.container}>
            {data.tabsItems.map((item) => (
                <button
                    className={`${styles.tab_item}  ${data.activeTab === item.value ? "bg-white text-indigo-600 shadow-md tab_active" : "text-gray-700 hover:text-indigo-600"}`}
                    onClick={() => data.setActiveTab(item.value)}
                >
                    {item.label}
                </button>
            ))}
        </div>
    );
};

export default Tabs;
